package com.example.mystybag.appCore.model.pages

data class CompanyResponsiblePerson(
    val id: Long,
    val firstName: String,
    val lastName: String,
    val phoneNumber: String,
    val dialCode: String
)

data class MenuUIState(
    val isLoading: Boolean = false,
    val isStaff: Boolean = false, // true when logged in as staff (employee)
    val iban: String? = null,
    val ibanConfirmationDate: String? = null, // Date when IBAN was confirmed
    val companyName: String? = null,
    val companyResponsiblePersons: List<CompanyResponsiblePerson> = emptyList(),
    val appVersion: String = "1.0.0"
)

